import { requestGet, requestPost } from '@/utils/requestTourist';

// 全部打卡营
export function getCampIndexPage(params: any) {
  return requestPost(`/v2/camp/api/index/page`, params);
}
// 列举打卡营产品
export function getCampProductist() {
  return requestGet('/v2/camp/api/index/list/product', {});
}
// 通过id获取打卡营
export function getCampById(campId: string) {
  return requestGet(`/v2/camp/api/index/get/id/${campId}`, {});
}
// 打卡营招生页
export function getRecruitStudents(campId: string, batchId?: string) {
  const url = batchId
    ? `/v2/camp/api/index/recruit/students/${campId}?batchId=${batchId}`
    : `/v2/camp/api/index/recruit/students/${campId}`;
  return requestGet(url, {});
}
